export const subscription = {
  titles: {
    subscription: "Suscripción",
    freeTrial: "Prueba Gratuita",
    expired: "Expirada",
  },

  status: {
    active: "Activa",
    canceled: "Cancelada",
    trialAccess: "PRUEBA GRATUITA",
    expiredAccess: "ACCESO EXPIRADO",
  },

  notices: {
    activeDesc:
      "Gestiona los detalles de tu suscripción y opciones de actualización.",
    canceledDesc:
      "Tu suscripción ha sido cancelada. Seguirás teniendo acceso hasta la fecha de vencimiento.",
    trialDesc:
      "Tienes acceso a las funcionalidades del sistema hasta la fecha de expiración.",
    expiredDesc:
      "Tu versión de prueba ha finalizado. Para seguir usando el servicio, suscríbete.",
    upgradeHint:
      "No pierdas acceso a funciones avanzadas, actualiza ahora tu suscripción",
    expiredHint:
      "Tu acceso ha expirado. Suscríbete para continuar disfrutando de todas las funcionalidades",
    needFullAccess: "¿Necesitas acceso completo?",
    choosePlan: "Elige un plan que se adapte a ti",
  },

  labels: {
    planActive: "Plan activo",
    stateNow: "Estado actual",
    trialPeriod: "Período de prueba",
    periodExpired: "Período Vencido",
    summary: "Resumen de la suscripción",
    timeLeft: "Tiempo restante",
    trialExpiresIn: "Tu prueba gratuita expira en {days} días",
    expirationDate: "Fecha de expiración",
    nextRenewal: "Próxima renovación",
    accessUntil: "Acceso disponible hasta",
    perUnit: "/ Por {unit}",
    unitRoom: "Habitación",
    unitRoomMultiple: "Múltiples habitaciones",

    unitApartmentLabel: "Uno o múltiples espacios",
    unitRoomLabel: "Múltiples habitaciones",
    unitCampingLabel: "Múltiples carpas",
    unitVillaLabel: "Un único espacio",
    unitApartment: "Apartamento",

    unitVilla: "Villa",
    unitCamping: "Camping",
    unitLodging: "Alojamiento",
    annualPlan: "Plan Anual",
    monthlyPlan: "Plan Mensual",

    // dentro de subscription.labels
    year: "año",
    month: "mes",
    eachYear: "cada año",
    eachMonth: "cada mes",
    scheduledCancelShort: "Cancelación programada",
    unitLicense: "Licencia(s)",
  },
  orderSummary: {
    title: "Resumen de la compra",
    subtotal: "Subtotal",
    discount: "Descuento",
    taxes: "Impuestos",
    totalRecurring: "Total recurrente",
    recursEvery: "Se cobra",
    annualEquivalent: "equivale a",

  },

  actions: {
    addUnit: "Agregar {unitLabel}",
    manageSubAndPayment: "Administrar suscripción y facturas",
    processing: "Procesando...",
    subscribeNow: "Suscribirme ahora",
    chooseAPlan: "Elegir un plan",
    goToSubscriptionPage: "Ir a planes",
  },

  confirmCancel: {
    title: "¿Cancelar Suscripción?",
    text: "Si cancelas, perderás acceso a tus servicios.",
    confirm: "Sí, cancelar",
    cancel: "No",
  },

  formats: {
    // Usa estas plantillas cuando renders cifras/fechas desde el componente
    priceTotalHTML: "{price}", // se usa con v-html ya formateado
    dateDDMMYYYY: "{date}", // el componente ya usa moment
  },

  modal: {
    title: "¡Suscripción Activada!",
    details: "Detalles de la suscripción",
    welcomeTitle: "¡Bienvenido a WA Checkin ",
    welcomeBody:
      "Ahora tienes acceso completo a nuestras herramientas de check-in vía WhatsApp, sincronización con OTAs, chatbot con IA, automatización y mucho más.",
    feature1: {
      title: "Gestiona tarifas y disponibilidad",
      desc: "Edita fácilmente tus precios y controla la ocupación de tu alojamiento en tiempo real, todo desde un solo lugar.",
    },
    feature2: {
      title: "Recibe reservas directas",
      desc: "Desde tu propio sitio web, los huéspedes podrán reservar directo, sin pasar por OTAs.",
    },
    schedule: {
      help: "Agenda una videollamada gratuita y te ayudaremos a configurar todo.",
      cta: "Agendar videollamada",
    },
  },

  sectionPlans: {
    title: "Listado de planes",
    confirm: {
      header: "Confirmar actualización de plan",
      loadingMsg: "Actualizando el plan, por favor espera.",
      body: "Estás a punto de cambiar el plan de tu cuenta a {plan}.",
    },
    actions: {
      cancel: "Cancelar",
      confirmUpgrade: "Confirmar actualización",
      goToBilling: "Ir a métodos de pago",
      accept: "Aceptar",
      updateSubscription: "Actualizar Suscripción", // NUEVA
    },
    success: {
      title: "Éxito",
      body: "Tu suscripción ha sido actualizada.",
    },
    errors: {
      processTitle: "Error al procesar la solicitud",
      unknownUpdate: "Error desconocido al actualizar la suscripción.",
      genericTitle: "Error",
      genericBody: "No se pudo actualizar la suscripción.",
    },
  },

  plans: {
    features: {
      installation: "Instalación personalizada con un asesor experto",
      fastSupport: "Soporte rápido por email, chat y teléfono",
      whatsappCheckin: "Check-in por WhatsApp",
      linkEmailCheckin: "Check-in por enlace / email",
      welcomeMessage: "Mensaje de bienvenida por WhatsApp y email",
      digitalSignature: "Firma digital de políticas",
      idScanner: "Escáner DNI/Pasaporte",
      sesHospedajesSend: "Envío automático de partes a SES HOSPEDAJES",
      reviewLink: "Envío de link de Review Google Places tras el check-out",
      smartLocks: "Conectamos con tus cerraduras inteligentes",
      channelManager1: "Channel Manager (Conexión con 1 OTA)",

      includesLite: "Todo lo del plan Lite",
      selfieVerification:
        "Verificación de huéspedes en check-in mediante selfie",
      unifiedInbox: "Bandeja de entrada unificada",
      upsellServices: "Ofrece servicios y experiencias por WhatsApp",
      paymentLinks: "Cobros a huéspedes (link de pago con tarjeta)",
      websiteBookings: "Página web con reservas y calendario sincronizado",
      channelManagerUnified:
        "Channel Manager (Calendarios unificados, +100 OTAs)",
      channelManagerCentralPrices:
        "Channel Manager (Gestión de precios centralizados)",
      guestSupportOption: 'Posibilidad de contratar "Atención al Huésped"',

      includesStandard: "Todo lo del plan Standard",
      centralizedPriceManager: "Gestor de precios centralizados",
      aiChatbot: "Chatbot IA WhatsApp (FAQ y automatización)",
      Chatbot: "Chatbot IA WhatsApp (FAQ y automatización)",
      googleVacationRentals: "Integración con Google Vacation Rentals",
      whatsappReminders: "Recordatorios por WhatsApp para tus huéspedes",
      eInvoicingSoon: "Facturación electrónica (Próximamente)",
      prioritySupport: "Soporte prioritario",
    },
  },

  planCard: {
    perSlash: "/por", // usado como separador "/por {unidad}"
    infoTitle: "Información del plan",
    update: "Actualizar",
    subscribe: "Suscribirme",
    currentPlan: "Plan actual",
    byApartment: "por apartamento",
    byVilla: "por villa",
    byCamping: "por camping",
    byRoom: "por habitación",
    byUnit: "por unidad",
    totalMonthly: "Total mensual",
    includedFeatures: "Servicios incluidos",
    moreFeatures:
      "Suscríbete y aprovecha todas las características de WA Checkin.",
  },
  services: {
    title: "Servicios adicionales",
    ctaComingSoon: "Próximamente",
    guestSupport: {
      title: "Servicio de Atención al Huésped",
      subtitle:
        "Nos encargamos por ti de los WhatsApp y llamadas de tus huéspedes.",
      desc: "Les ayudamos con el check-in, resolvemos sus dudas y también atendemos llamadas de reservas directas. Así tú te relajas, y ellos tienen una experiencia 10 desde el primer contacto.",
    },
    chatbot: {
      title: "ChatBot IA",
      activeService: "Servicio Activo",
      desc: "Agrega el servicio de chatbot con inteligencia artificial y automatiza las consultas de tus huéspedes de forma rápida y eficiente.",
      activateCta: "Activar servicio",
      confirm: {
        header: "Confirmar Activación",
        loadingMsg: "Activando servicio de ChatBot, por favor espera.",
        body: "Estás a punto de activar el servicio de ChatBot IA para tus {units} alojamientos.",
      },
      discount: {
        applied: "Descuento aplicado:",
        couponFallback: "Cupón",
      },
      pricing: {
        unitPrice: "Precio unitario:",
        quantity: "Cantidad:",
        totalToPay: "Total a pagar:",
      },
    },
  },

  invoices: {
    title: "Facturas y Recibos",
    created: "Creado",
    status: "Estado",
    amount: "Monto",
    paid: "Pagado",
    unpaid: "Pendiente",
    viewInvoice: "Ver factura",
    empty: "No tienes facturas todavía.",
  },

  updateModal: {
    header: "Agregar {unitLabel}s",
    body: "Agrega la cantidad de {unitLabelPlural} en tu suscripción.",
    pricing: {
      discountApplied: "Descuento aplicado a la suscripción:",
      unitPrice: "Precio unitario:",
      quantity: "Cantidad:",
      totalNewUnits: "Total por nuevas unidades:",
      newSubscriptionTotal: "Nuevo valor total de suscripción:",
    },
    prorationNote:
      "Los cambios en la suscripción son prorrateados según los días restantes del período actual. El próximo mes se aplicará el cobro completo.",
  },

  page: {
    findRightPlan: "Encuentra el plan adecuado para ti",
    enterAmount: "Ingresa la cantidad",
    numberOf: "Número de {unit}",
    currency: "Moneda",
  },

  billing: {
    title: "Selecciona periodo",
    subtitle: "Elige cómo quieres pagar",
    monthly: "Mensual",
    annual: "Anual",
    discountShort: "−{percent}%",
    monthlyDesc: "Paga mes a mes",
    annualDesc: "Paga por año completo",
    monthlyInfo: "Facturación mensual",
    annualInfo: "Facturación anual con 2 meses gratis",
    annualSavings: "Ahorra 20% con facturación anual",
    save: "Ahorra {percent}%",
    month: "mes",
  },

  multi: {
    title: "Elige tu suscripción",
    subtitle: "Combina diferentes tipos de propiedades según tus necesidades",
    selectPropertyType: "Selecciona el tipo de propiedad",
    selectPlan: "Elige tu Plan",
    preview: "Vista Previa",
    addToCart: "Agregar al carrito",
    alreadyInCart: "Ya está en el carrito",
    popular: "Más Popular",
    mostPopular: "Más Popular",
    lockedNotice: "El plan y el periodo de cobro están bloqueados por el carrito. Vacíalo para cambiarlos.",
    addons: "Servicios adicionales",
    addonAppliesAll: "Aplica a todos los planes",
  },

  cart: {
    title: "Carrito de compras",
    itemsCount: "{count} elemento(s)",
    empty: "Tu carrito está vacío",
    emptyMessage: "Agrega planes de suscripción para comenzar",
    emptyDetail: "Selecciona un tipo de propiedad y plan para continuar",
    itemAdded: "Elemento agregado",
    itemAddedDetail: "El plan ha sido agregado a tu carrito",
    itemExists: "Elemento ya existe",
    itemExistsDetail: "Este plan ya está en tu carrito",
    viewFeatures: "Ver características",
    moreFeatures: "y {count} más...",
    subtotal: "Subtotal",
    annualSavings: "Ahorro anual",
    total: "Total",
    clearAll: "Limpiar Todo",
    checkout: "Procesar Pago",
    processing: "Procesando...",
    securePayment: "Pago 100% Seguro",
  },
};
